import { EYandexMetrikaEvent } from 'common/const';
import { getAppSettings } from 'common/settings';
import { TMetrikaParams } from 'common/types/metrika.types';

const COUNTER_ID = 88190180;

type TYm = (counterId: number, method: string, ...args: unknown[]) => void;

/* Цель Метрики с параметрами визита. Цели засчитываются только сборкой master (REACT_APP_METRIKA_GOALS,
 *  pay-host R-2), не по хосту страницы; в остальных сборках (dev, локальный запуск) - в консоль, чтобы
 *  воронку было чем проверить до прода (metrika-funnel R-6). Сбой счётчика оплате не мешает и в Sentry не идёт (R-7). */
export const sendYandexMetrikaEvent = (eventName: EYandexMetrikaEvent, params?: TMetrikaParams) => {
  try {
    if (!getAppSettings().metrikaGoals) {
      console.debug('[metrika]', eventName, params ?? {});
      return;
    }

    const ym = (window as Window & { ym?: TYm }).ym;

    if (!ym) {
      return;
    }

    if (params) {
      ym(COUNTER_ID, 'reachGoal', eventName, params);
    } else {
      // Прежние цели без параметров - прежний вызов
      ym(COUNTER_ID, 'reachGoal', eventName);
    }
  } catch {
    // аналитика не влияет на страницу
  }
};
